import React from 'react'
import Resume from '../resumeComponent/resume'

const ResumePage = () => {
  return (
    <main className="animate__fadeIn animate__animated animate__fadeIn animate__fast">
      <Resume />
    </main>
  )
}

export default ResumePage